import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { api } from "@/lib/api";
import { AuthLayout } from "@/components/auth-layout";
import { Button, Field } from "@/components/kit";
import { useToast } from "@/components/toast";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const toast = useToast();
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const send = async (e) => {
    e?.preventDefault();
    setError("");
    if (!email.trim()) return setError("Renseignez votre e-mail.");
    setLoading(true);
    try {
      await api("/auth/forgot-password", { method: "POST", body: { email: email.trim() } });
      setStep("code");
      toast("Si un compte existe, un code vous a été envoyé par e-mail.", "info");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const reset = async (e) => {
    e?.preventDefault();
    setError("");
    if (code.trim().length !== 6) return setError("Le code contient 6 chiffres.");
    if (pw.length < 8) return setError("Le mot de passe doit contenir 8 caractères minimum.");
    setLoading(true);
    try {
      await api("/auth/reset-password", { method: "POST", body: { email: email.trim(), code: code.trim(), new_password: pw } });
      toast("Mot de passe modifié. Vous pouvez vous connecter.");
      navigate(-1);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const err = error ? <p data-testid="forgot-error" role="alert" className="text-sm text-[#EB5757]">{error}</p> : null;
  return (
    <AuthLayout title="Mot de passe oublié" testID="forgot-password-screen">
      <p className="t-body">
        {step === "email"
          ? "Saisissez votre e-mail : nous vous enverrons un code de réinitialisation."
          : `Saisissez le code reçu à ${email} et choisissez un nouveau mot de passe.`}
      </p>
      {step === "email" ? (
        <form onSubmit={send} noValidate className="flex flex-col gap-4">
          <Field testID="forgot-email-input" label="E-mail" type="email" autoComplete="email" value={email} onChangeText={setEmail} />
          {err}
          <Button testID="forgot-send-button" type="submit" title="Recevoir un code" loading={loading} />
        </form>
      ) : (
        <form onSubmit={reset} noValidate className="flex flex-col gap-4">
          <Field testID="forgot-code-input" label="Code à 6 chiffres" inputMode="numeric" maxLength={6} autoComplete="one-time-code" value={code} onChangeText={setCode} />
          <Field testID="forgot-new-password-input" label="Nouveau mot de passe" type="password" autoComplete="new-password" value={pw} onChangeText={setPw} />
          {err}
          <Button testID="forgot-reset-button" type="submit" title="Modifier mon mot de passe" loading={loading} />
          <Button testID="forgot-resend-button" title="Renvoyer un code" variant="ghost" onClick={() => send()} />
        </form>
      )}
    </AuthLayout>
  );
}
